export const VENDOR_ROUTE = "/vendor";
